import React from 'react';
import { Link } from 'react-router-dom';

export const Support = () => {
  return (
    <div className="privacy-container">
      {/* Retro grain texture overlay */}
      <div className="grain-overlay"></div>
      
      <div className="privacy-content">
        <Link to="/" className="privacy-back-link">← Back to Home</Link>
        
        <h1 className="privacy-title">Support</h1>
        
        <div className="privacy-text">
          <p>
            If you have any questions, need support, or would like to provide feedback, please contact us at: <a href="mailto:geteranos@gmail.com" className="privacy-email-link">geteranos@gmail.com</a>
          </p>
          <p style={{ marginBottom: 0, marginTop: '1.5rem' }}>
            If you'd like to delete your account, please <Link to="/delete-account" className="privacy-email-link">click here</Link>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Support;

